import PropTypes from 'prop-types';
import { getUnitOptions } from '@/utils/unitUtils';
import { FormProvider, useForm } from 'react-hook-form';
import Select from '@/components/core/form/Select';
import FormRow from '@/components/core/form/FormRow';
import { stringify } from '@/utils/miscUtils';

const UnitConverterForm = ({ defaultValues, onSubmit, unitOptions }) => {
  const methods = useForm({ defaultValues });
  const { handleSubmit } = methods;
  const { levelizeBy } = defaultValues;
  const levelizeByOptions = [{ value: levelizeBy, label: levelizeBy }];

  return (
    <div className="group node">
      <FormProvider {...methods}>
        <div className="mt-2 grid grid-cols-3 group-[.emissions]:grid-cols-5 gap-2">
          <form onChange={handleSubmit(onSubmit)}>
            <FormRow label="Functional Unit" name="levelization_unit">
              <div className="flex join w-full items-center mb-2 rounded-none">
                <Select name="levelizeBy" className="join-item w-full truncate" options={levelizeByOptions} />
                <Select className="join-item w-full truncate" name="levelization_unit" options={unitOptions} />
              </div>
            </FormRow>
          </form>
        </div>
      </FormProvider>
    </div>
  );
};

UnitConverterForm.propTypes = {
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  unitOptions: PropTypes.array,
};

const UnitConverter = ({ template, onSubmit }) => {
  const { output } = template;

  const { unit, convertible_units, label } = output;
  const unitOptions = getUnitOptions(convertible_units);

  if (!output) {
    return null;
  }

  return (
    <UnitConverterForm
      defaultValues={{ levelization_unit: stringify(unit), levelizeBy: label }}
      unitOptions={unitOptions}
      onSubmit={onSubmit}
    />
  );
};

UnitConverter.propTypes = {
  template: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default UnitConverter;
